import type { components, paths } from "@securityjourney/svc-api-tokens/src/gen/api_tokens";

import { getCurrentSelectedTenant } from "../utils";
import { OpenApiFetchWrapper } from "./openApiFetchWrapper";

export type IssueApiTokenResponse =
  components["schemas"]["securityjourney.proto.api_tokens.IssueApiTokenResponse"];
export type ListApiTokenResponse =
  components["schemas"]["securityjourney.proto.api_tokens.ListApiTokenResponse"];
export type RevokeApiTokenResponse =
  components["schemas"]["securityjourney.proto.api_tokens.RevokeApiTokenResponse"];

class ApiTokensClient extends OpenApiFetchWrapper<paths> {
  constructor() {
    super();
  }

  async issueApiToken(label: string, entitlements: string[]) {
    const tenant = getCurrentSelectedTenant();
    if (!tenant) return { data: null, error: new Error("No tenant selected") };
    // `tenant` is bound from the path param; the request body is only { label, entitlements }.
    return await this.post("/svc/api-tokens/{tenant}", {
      params: { path: { tenant } },
      body: { label, entitlements },
    });
  }

  async listApiTokens(excludedEntitlements?: string[]) {
    const tenant = getCurrentSelectedTenant();
    if (!tenant) return { data: null, error: new Error("No tenant selected") };

    const query = excludedEntitlements ? { excludedEntitlements } : {};

    return await this.get("/svc/api-tokens/{tenant}", {
      params: { path: { tenant }, query },
    });
  }

  async listApiTokensWithEntitlements(entitlements: string[]) {
    const tenant = getCurrentSelectedTenant();
    if (!tenant) return { data: null, error: new Error("No tenant selected") };
    return await this.get("/svc/api-tokens/{tenant}", {
      params: { path: { tenant }, query: { entitlements } },
    });
  }

  async revokeApiToken(uuid: string) {
    const tenant = getCurrentSelectedTenant();
    if (!tenant) return { data: null, error: new Error("No tenant selected") };
    return await this.delete("/svc/api-tokens/{tenant}/{uuid}", {
      params: { path: { tenant, uuid } },
    });
  }
}

let apiTokensClientInstance: ApiTokensClient | null = null;

export const getApiTokensClient = (): ApiTokensClient => {
  if (!apiTokensClientInstance) {
    apiTokensClientInstance = new ApiTokensClient();
  }
  return apiTokensClientInstance;
};
